import axios from 'axios'

export const activities = {
    state:{
        activities:[],
    }, 
    mutations:{
        SetActivities(state, data){
          state.activities = data.activities
        },
        
    },
    actions:{
      GetActivities: ({commit})=>{
          return new Promise((resolve, reject)=>{
              axios.get('/activities')
              .then(({status, data})=>{
                if(status === 200){
                  resolve(data);
                  commit("SetActivities", data)
                }
              })
              .catch((error)=>{
                reject(error);
              });
            })
      },
      GetActivitiesWithFilter: ({commit}, payload)=>{
        return new Promise((resolve, reject)=>{
            axios.get(`/activities?type=${payload.type}`)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("SetActivities", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
      },
        
    },
}